import { render, staticRenderFns } from "./BaseLayout.vue?vue&type=template&id=74b42158&scoped=true&"
import script from "./BaseLayout.vue?vue&type=script&lang=js&"
export * from "./BaseLayout.vue?vue&type=script&lang=js&"
import style0 from "./BaseLayout.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BaseLayout.vue?vue&type=style&index=1&id=74b42158&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b42158",
  null
  
)

export default component.exports